import React, { useEffect, useState } from 'react';
import JalaliDatePicker from '../../../components/common/JalaliDatePicker';
import { apiClient } from '../../../components/api/ApiClient';

function MainInfoStep({ formData, onDataChange, readOnly, branches = [], ...rest }) {
    console.log('finalDate:', formData.finalDate);
    console.log('formData:', formData);
    const handleChange = (e) => {
        const { name, value } = e.target;
        const val = (name === 'invoiceNum') ? parseInt(value, 10) : value;
        onDataChange({ [name]: val });
    };

    const handleDateChange = (dateString) => {
        onDataChange({ finalDate: dateString });
    };

    return (
        <div className="step-content">
            <h5 className="mb-4">اطلاعات اصلی صورتحساب</h5>
            <div className="row">
                <div className="col-lg-4 col-md-6 col-12 mb-3">
                    <label htmlFor="storeNum" className="form-label">
                        نام شعبه {!readOnly && <span className="text-danger">*</span>}
                    </label>
                    <select
                        className="form-select"
                        id="storeNum"
                        name="storeNum"
                        value={formData.storeNum}
                        onChange={handleChange}
                        required
                    >
                        {branches.map(branch => (
                            <option key={branch.id} value={branch.taxMemoryId}>
                                {branch.name || `شعبه ${branch.code}`}
                            </option>
                        ))}
                    </select>
                </div>
                
                <div className="col-lg-4 col-md-6 col-12 mb-3">
                    <label htmlFor="invoiceNum" className="form-label">
                        شماره صورتحساب {!readOnly && <span className="text-danger">*</span>}
                    </label>
                    <input
                        type="number"
                        className="form-control"
                        id="invoiceNum"
                        name="invoiceNum"
                        value={formData.invoiceNum || ""}
                        onChange={handleChange}
                        placeholder="شماره صورتحساب"
                        disabled={true}
                        required
                    />
                </div>

                <div className="col-lg-4 col-md-6 col-12 mb-3">
                    <label htmlFor="finalDate" className="form-label">
                        تاریخ صدور صورتحساب {!readOnly && <span className="text-danger">*</span>}
                    </label>
                    <JalaliDatePicker
                        value={formData.finalDate}
                        onChange={handleDateChange}
                        disabled={readOnly}
                        placeholder="12:00 1402/01/01"
                        showTime={true}
                    />
                </div>
            </div>
        </div>
    );
}

export default MainInfoStep;